import styled from '@emotion/styled';
import { Theme } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import { MenuItem } from '@mui/material';

export const StyledTopNavBarWrapper = styled.div<{ theme?: Theme }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding-block: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.customSecondary.neutral[500]};
`;

export const StyledMenu = styled(Menu)<{ theme?: Theme }>`
  .MuiPaper-root {
    background-color: ${({ theme }) => theme.palette.customSecondary.background.surface};
    color: ${({ theme }) => theme.palette.customSecondary.neutral[100]};
    box-shadow: 0 4px 10px ${({ theme }) => theme.palette.customSecondary.neutral[400]};
  }
`;

export const StyledMenuItem = styled(MenuItem)<{ theme?: Theme }>`
  transition: background-color 0.3s;

&:hover {
  background-color: ${({ theme }) => theme.palette.customSecondary.chart[2]}14};
}
`;
